"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHandleGxChange = exports.getHandleGxDone = exports.getHandleGxV1Done = void 0;
const gx_1 = require("@kyruus/gx");
const Tracking_1 = require("../../lib/constants/Tracking");
const Actions_1 = require("../../lib/constants/Actions");
/**
 * Handles what happens when we're done with a GX v1 flow.
 * This means the the flow passed or failed.
 * We update the machine and tracking info based on that state.
 *
 * Note: After a GX v1 flow has been completed with answers from a user,
 * any user change to an answer will call the `onDone` handler instead of the `onChange` handler.
 *
 * @param {Object} props
 * @param {function} props.send  machine `send` function
 * @param {function} props.track  tracking function
 * @returns {function} return onDone handler function
 */
const getHandleGxV1Done = ({ send, track }) => ({ name, ctx, curState, trackingData }) => {
    if (curState === gx_1.constants.states.doneLeft) {
        track(Tracking_1.userEvents.GX_QUESTION_ANSWER, Object.assign(Object.assign({}, trackingData), { status: gx_1.constants.trackingStatuses.FAIL, flow_name: name }));
        send({
            type: Actions_1.GX_V1_FAILED,
            data: ctx
        });
    }
    if (curState === gx_1.constants.states.doneRight) {
        track(Tracking_1.userEvents.GX_QUESTION_ANSWER, Object.assign(Object.assign({}, trackingData), { status: gx_1.constants.trackingStatuses.SUCCESS, flow_name: name }));
        send({
            type: Actions_1.GX_PASSED,
            data: ctx
        });
    }
};
exports.getHandleGxV1Done = getHandleGxV1Done;
/**
 * Handles what happens when we're done with a GX v2 flow and the Gx question set has passed, failed, or errored.
 * We update the tracking info based on the state,
 * and conditionally update the state machine.
 *
 * @param {Object} props
 * @param {function} props.send  machine `send` function
 * @param {function} props.track  tracking function
 * @param {string} props.event  UI event to be fired conditionally
 * @returns {function} return onDone handler function
 */
const getHandleGxDone = ({ send, track, event }) => ({ name, ctx, curState, trackingData }) => {
    const mapStateToTrackingStatus = {
        [gx_1.constants.states.error]: gx_1.constants.trackingStatuses.ERROR,
        [gx_1.constants.states.warning]: gx_1.constants.trackingStatuses.FAIL,
        [gx_1.constants.states.done]: gx_1.constants.trackingStatuses.SUCCESS,
        [gx_1.constants.states.skipped]: gx_1.constants.trackingStatuses.SUCCESS
    };
    track(Tracking_1.userEvents.GX_QUESTION_ANSWER, Object.assign(Object.assign({}, trackingData), { status: mapStateToTrackingStatus[curState], flow_name: name }));
    if (curState === gx_1.constants.states.done ||
        curState === gx_1.constants.states.skipped) {
        send({
            type: event,
            data: ctx
        });
    }
};
exports.getHandleGxDone = getHandleGxDone;
/**
 * Handles what happens when a user has answered a question from a GX question set.
 *
 * - This isn't necessarily a `change/blur` event. e.g:
 *  For a DOB input, an answer would only make it through if it was valid.
 *  Meaning the user has entered a valid date in the input.
 *
 * - We track only if there aren't any errors.
 *
 * @param {Object} props
 * @param {function} props.send  machine `send` function
 * @param {function} props.track  tracking function
 * @param {string} props.event  UI event to be fired on done
 * @returns {function} return change handler function
 */
const getHandleGxChange = ({ send, track, event }) => ({ name, errors = [], trackingData }) => {
    // we send an `answered` event even when there are errors
    // to adjust to the correct state from "answered" to "answer has changed"
    send(event);
    if (errors.length === 0) {
        track(Tracking_1.userEvents.GX_QUESTION_ANSWER, Object.assign(Object.assign({}, trackingData), { flow_name: name, status: gx_1.constants.trackingStatuses.INCOMPLETE }));
    }
};
exports.getHandleGxChange = getHandleGxChange;
//# sourceMappingURL=gx-handlers.js.map